import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { AchievementBackofficeViewModel } from "@playcharge/common/models/backend/achievements/backoffice/achievement-backoffice-view-model";
import { AchievementEditModel } from "@playcharge/common/models/backend/achievements/backoffice/achievement-edit-model";
import { Observable } from "rxjs";
import { ApiUtils } from "../utils/api-utils";
import { ApiRoutes } from "../models/constants/api-routes";

@Injectable({
    providedIn: "root",
})
export class ApiAchievementsService {
    private _httpClient = inject(HttpClient);

    public getAll(): Observable<AchievementBackofficeViewModel[]> {
        return this._httpClient.get<AchievementBackofficeViewModel[]>(
            ApiUtils.buildUrl(ApiRoutes.achievements.root),
        );
    }

    public getById(achievementId: number): Observable<AchievementBackofficeViewModel> {
        return this._httpClient.get<AchievementBackofficeViewModel>(
            ApiUtils.buildUrl(
                ApiRoutes.achievements.achievement,
                new Map<string, string>([["achievementId", achievementId.toString()]]),
            ),
        );
    }

    public createOrUpdate(model: AchievementEditModel): Observable<AchievementBackofficeViewModel> {
        return this._httpClient.post<AchievementBackofficeViewModel>(
            ApiUtils.buildUrl(ApiRoutes.achievements.root),
            model,
        );
    }

    public delete(achievementId: number): Observable<void> {
        return this._httpClient.delete<void>(
            ApiUtils.buildUrl(
                ApiRoutes.achievements.root,
                new Map<string, string>([["achievementId", achievementId.toString()]]),
            ),
        );
    }
}
